import React, { useState } from 'react';
import PropTypes from 'prop-types';

import styles from './divisions.scss';
import Popup from '../../../Popup';
import { CheckBox } from '../../../Form';

const CloseRegistrationConfirmPopup = (props) => {
    const { divisionIndex, onCtaClick, onCloseClick } = props;

    const [doNotShowAgain, setDoNotShowAgain] = useState(false);

    const onChangeDoNotShowAgain = (value) => {
        setDoNotShowAgain(value);
    };

    return (
        <Popup
            className="popup-sm"
            popUpClassName={styles.confirmPopup}
            onCloseClick={onCloseClick}
            closeOnClickOutside={false}
            config={{
                fullScreen: false,
                noPadding: true,
                scrollable: false,
                showCloseIcon: false,
            }}
        >
            <h6 className={styles.title}>
                Close Registration for This Division?
            </h6>
            <p className={styles.description}>
                <div className="mb16">You’re selecting to <strong>immediately close registration</strong> for this division. This means <strong>new players can’t register</strong>, and it <strong>overrides any existing registration end dates</strong>.</div>
                <div>Important Details:</div>
                <li><strong>Freezes Waitlist Logic:</strong> Closing registration freezes automatic waitlist logic. Players will only move from the waitlist to main positions via <strong>manual adjustments</strong> you make (which are only accessible when the division is closed).</li>
                <li><strong>Reopening:</strong> You can reopen the division, but the <strong>waitlist logic stays frozen</strong>. Any new registrations will still go to the waitlist, requiring continued manual management from you.</li>
                <li><strong>Event Profile:</strong> This division will display as “<strong>Registration Closed.</strong>”</li>
                <div className="mt16">Are you sure you want to close registration for this division?</div>
            </p>
            <CheckBox
                controlled={true}
                id={`doNotShowAgain`}
                customLabel="Do not show me this modal again."
                checked={doNotShowAgain}
                onChange={onChangeDoNotShowAgain}
            />
            <div className="row">
                <div className={`${styles.cancelBtn} col-md-6 mb8`}>
                    <button
                        onClick={onCloseClick}
                        type="button"
                        className={`btn btn-default btn-sm text-uppercase btn-block`}
                    >
                        Cancel
                    </button>
                </div>
                <div className={`${styles.confirmBtn} col-md-6 mb8 `}>
                    <button
                        onClick={() => onCtaClick(divisionIndex, doNotShowAgain)}
                        type="button"
                        className={`btn btn-primary btn-sm text-uppercase btn-block`}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </Popup>
    );
};

CloseRegistrationConfirmPopup.propTypes = {
   divisionIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

CloseRegistrationConfirmPopup.defaultProps = {
};

export default CloseRegistrationConfirmPopup;
